import { Settings } from "../../Settings";
import CachedInstance from "../cache/CachedInstance";

export default class InfoText extends CachedInstance {
    constructor() {
        super();

        /**
         * @type {string}
         */
        this.text = '';
        // /**
        //  * @type {Color}
        //  */
        // this.textColor = null;
        /**
         * @type {number}
         */
        this.textX = 0;
        /**
         * @type {number}
         */
        this.textY = 0;
        /**
         * @type {number}
         */
        this.frameCount = 0;
        /**
         * @type {number}
         */
        this.incrementX = 0;
        /**
         * @type {number}
         */
        this.incrementY = 0;
    
        /**
         * We move text every other frame.
         * @type {boolean}
         */
        this.frameToggle = false;
    
    }

    /**
     * @param {string} text 
     */
    set(text) {
        this.text = text;

        this.incrementX = this.calculateTextMotion();
        this.incrementY = 1 + (Math.random() > 0.5 ? 1 : 0);
        this.frameToggle = true;
        this.frameCount = 0;
    }

    // /**
    //  * @param {string} text 
    //  * @param {Color} textColor 
    //  */
    // set(text, textColor) {
    //     this.text = text;
    //     this.textColor = textColor;

    //     this.incrementX = this.calculateTextMotion();
    //     this.incrementY = -1 - (Math.random() > 0.5 ? 1 : 0);
    //     this.frameToggle = true;
    //     this.frameCount = 0;
    // }

    calculateTextMotion() {
        // Move 1 or 2 pixels
        const motion = 1 + (Math.random() > 0.5 ? 1 : 0);

        // Move left or right
        if (Math.random() < 0.5) {
            return -motion;
        }
        else {
            return motion;
        }
    }

    /**
     * @returns {boolean}
     */
    isTextFinished() {
        return this.frameCount >= Settings.text.textFrameDuration;
    }

    /**
     * @param {number} frameTimeRatio The number of frames passed.
     * @return {boolean} true if the text is finished.
     */
    updateTextForFrame(frameTimeRatio) {
        if (this.frameToggle) {
            if (Math.random() < 0.5) {
                this.textX += this.incrementX;
            }
            this.textY -= this.incrementY; // subtract y to move the text up the screen
        }
        this.frameToggle = !this.frameToggle;

        this.frameCount += frameTimeRatio;

        return this.textY <= 0 || this.isTextFinished();
    }

}